import precisionRound from './precisionRound';

export default function delimiter(val, precision = 0) {
  let str = `${val}`; // convert to string
  if (precision > 0) {
    str = `${precisionRound(Number(val), precision)}`;
  }
  const x = str.split('.');
  const delimited = x[0].replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  let result = `${val < 0 ? '-' : ''}${delimited}`;
  if (precision > 0 && x[1]) {
    result += `,${x[1]}`;
  }
  return result;
}
